import React from 'react';

import { Group, NumberInput, Stack, Text } from '@mantine/core';

import { blockNonInteger, RoundsRepsResult } from './types';

interface RoundsRepsInputProps {
  value: RoundsRepsResult;
  onChange: (value: RoundsRepsResult) => void;
  enlarged?: boolean;
}

const RoundsRepsInput = ({ value, onChange, enlarged = false }: RoundsRepsInputProps): JSX.Element => (
  <Group spacing='xs' align='flex-end' noWrap>
    <Stack spacing={4} sx={{ flex: 1 }}>
      <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
        Rounds
      </Text>
      <NumberInput
        value={value.rounds}
        onChange={rounds => onChange({ ...value, rounds })}
        min={0}
        precision={0}
        inputMode='numeric'
        onKeyDown={blockNonInteger}
        size={enlarged ? 'xl' : 'md'}
      />
    </Stack>
    <Text pb={6} align='center' weight={700} size='xl' color='dimmed'>
      +
    </Text>
    <Stack spacing={4} sx={{ flex: 1 }}>
      <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
        Reps
      </Text>
      <NumberInput
        value={value.reps}
        onChange={reps => onChange({ ...value, reps })}
        min={0}
        precision={0}
        inputMode='numeric'
        onKeyDown={blockNonInteger}
        size={enlarged ? 'xl' : 'md'}
      />
    </Stack>
  </Group>
);

export default RoundsRepsInput;
